import { createApp, computed } from "vue";
import { createPinia } from 'pinia';
import App from '@/App.vue';
import router from '@/router';
import i18n from "@/locales/i18n";
import { useLanguageStore } from '@/store/language';
import VueLazyload from 'vue3-lazyload';
import axios from "axios";
import { eventBus } from '@/eventBus';
import { useAuthStore } from './store/auth';
import helpers from "@/helpers";
import $ from 'jquery';
import 'jquery-nice-select';
import './assets/css/nice-select.css';

// Make jQuery globally accessible
window.$ = window.jQuery = $;

function initializeApp() {
  const app = createApp(App);

  let requestCount = 0;
  function showLoading() {
    requestCount++;
    eventBus.emit('loading', true);
  }
  
  function hideLoading() {
    requestCount--;
    if (requestCount === 0) {
      eventBus.emit('loading', false);
    }
  }
  axios.interceptors.request.use(config => {
    showLoading();
    return config;
  }, error => {
    hideLoading();
    return Promise.reject(error);
  });
  
  axios.interceptors.response.use(response => {
    hideLoading();
    return response;
  }, error => {
    hideLoading();
    return Promise.reject(error);
  });
  

  router.beforeEach((to, from, next) => {

    const authStore = useAuthStore()
    const isAuthenticated = authStore.getIsloggedIn
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!isAuthenticated) {
        // User is not authenticated, redirect to login page
        next('/')
      }
    }

    let config = helpers.getConfig();
    let title = config? config.name: "Mars Gaming";

    // Default title if domain is not matched
    let defaultTitle = to.meta.title || "Mars Gaming";
    let defaultDescription = to.meta.description || "";

    // Set document title from domain
    document.title = (defaultTitle + (title ? " | " + title : ""));

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', defaultDescription);
    } else {
      const description = document.createElement('meta');
      description.name = 'description';
      description.content = defaultDescription;
      document.head.appendChild(description);
    }

    next();
  });
  

  app.use(createPinia())
  .use(router)
  .use(i18n)
  .use(VueLazyload, {
    preLoad: 1.3,
    error: require('@/assets/img/lazyload/error.webp'),
    loading: require('@/assets/img/lazyload/placeholder.webp'),
    attempt: 1
  })

  return app;
}

// Initialize the Vue application
const app = initializeApp();
const languageStore = useLanguageStore();
languageStore.initLocale();

// Apply global jQuery logic
app.mixin({
  mounted() {
    // Apply Nice Select globally
    $('select').niceSelect();

    // // Custom dropdown behavior
    // $(document).click(function () {
    //   $('.dropdown-menu.show').removeClass('show');
    // });

    // $('body').on('click', '.apto-trigger-dropdown', function (e) {
    //   e.stopPropagation();
    //   $(this).closest('.apto-dropdown-wrapper').find('.dropdown-menu').toggleClass('show');
    // });

    // $('body').on('click', '.dropdown-item', function (e) {
    //   e.stopPropagation();
    //   let $selectedValue = $(this).val();
    //   let $icon = $(this).find('svg');
    //   let $btn = $(this).closest('.apto-dropdown-wrapper').find('.apto-trigger-dropdown');

    //   $(this)
    //     .closest('.apto-dropdown-wrapper')
    //     .find('.dropdown-menu')
    //     .removeClass('show')
    //     .attr('data-selected', $selectedValue);

    //   $btn.find('svg').remove();
    //   $btn.prepend($icon[0].outerHTML);
    // });
  },
});

app
  .provide(
    "isRtlLayout",
    computed(() => languageStore.isRtlLayout)
  )
  .mount('#app');
